export const convertSecsToHHMMSS = (secs: number): [number, number, number] => {
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor(secs / 60) % 60;
  const seconds = secs % 60;

  return [hours, minutes, seconds];
};

export const timeFormat = (receivedSeconds: number) => {
  return convertSecsToHHMMSS(receivedSeconds)
    .map((v) => (v < 10 ? `0${v}` : v))
    .join(':');
};

const formatSecondsToTime = (receivedSeconds: number, full = false) => {
  const [_hours, _minutes, _seconds] = convertSecsToHHMMSS(receivedSeconds);

  const hours = _hours.toString().padStart(2, '0');
  const minutes = _minutes.toString().padStart(2, '0');
  const seconds = _seconds.toString().padStart(2, '0');

  let response = '';

  if (_hours) {
    response += `${hours}h`;
  }

  if (_minutes) {
    response += `${minutes}min`;
  }

  if (_seconds && (full || (!_hours && !_minutes))) {
    response += `${seconds}seg`;
  }

  return response;
};

export default formatSecondsToTime;
